import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    sitesInTransit: simpleReducer(false, {
        REQUESTING_SITES: true,
        RECEIVED_SITES: false,
    }),

    all_sites: simpleReducer([], {
        REQUESTING_SITES: [],
        RECEIVED_SITES: function (a) {
            return a.payload.response.sites;
        },
    }),

    selectedSiteId: simpleReducer('', {
        SELECT_SITE: (a) => a.payload.siteId,
    }),

    showAlert: simpleReducer(false, {
        SHOW_ALERT: function (action_response) {
            return action_response.payload.showAlert;
        },
    }),

    serverId: simpleReducer('', {
        SET_SERVER_ID: function (action_response) {
            return action_response.payload.serverId;
        },
    }),

    hostId: simpleReducer('', {
        SET_HOST_ID: function (action_response) {
            return action_response.payload.hostId;
        },
    }),

    alertMessage: simpleReducer(
        { message: '', errorType: '' },
        {
            SET_ALERT_MESSAGE: function (action_response) {
                return {
                    message: action_response.payload.message,
                    errorType: action_response.payload.errorType,
                };
            },
        }
    ),
});



// WEBPACK FOOTER //
// ./app/reducers/sites.js